import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";

const deviceId = () => {
  let id = localStorage.getItem("ntv_device");
  if (!id) {
    id = (crypto.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`);
    localStorage.setItem("ntv_device", id);
  }
  return id;
};

const isStandalone = () =>
  window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;

// Anonymous heartbeat so the admin can see who is online right now (guests included).
export const PresenceTracker = () => {
  const loc = useLocation();
  const pathRef = useRef(loc.pathname);
  pathRef.current = loc.pathname;

  useEffect(() => {
    const ping = () => {
      if (document.visibilityState !== "visible" || !navigator.onLine) return;
      api.post("/presence", { device_id: deviceId(), path: pathRef.current, standalone: isStandalone() }).catch(() => {});
    };
    ping();
    const iv = setInterval(ping, 25000);
    document.addEventListener("visibilitychange", ping);
    return () => { clearInterval(iv); document.removeEventListener("visibilitychange", ping); };
  }, []);

  useEffect(() => {
    api.post("/presence", { device_id: deviceId(), path: loc.pathname, standalone: isStandalone() }).catch(() => {});
  }, [loc.pathname]);

  return null;
};
